{
  "id": 49,
  "location": "paris",
  "difficulty": "normal",
  "moves": 22,
  "kinds": 6,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "cupcake", "count": 32 }
  ],
  "stars": [3410, 4370],
  "board": [
    "# # . . . . # #",
    "# . . . . . . #",
    ". . . . . . . .",
    ". . . X X . . .",
    ". . . X X . . .",
    ". . . . . . . .",
    "# . . . . . . #",
    "# # . . . . # #"
  ],
  "calibration": { "runs": 1000, "winRate": 0.661, "movesLeft": 4.7, "closeLosses": 0.123, "target": 0.68 }
}
